import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';
import { ErrorsUtil } from '~shared/utils/errors.util';
import { ValidationError } from '~shared/models';

export class GATrackingCheckoutErrorsEvent implements GATrackingEvent {

  constructor(
    private errors: ValidationError[]) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.CheckoutErrors;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.Errors,
      label: ErrorsUtil.concatErrorsToString(this.errors)
    };
  }
}
